import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer } from '@mui/material';
const CustomDrawer = ({ open, onClose, children, ...rest }) => {
    return (_jsx(Drawer, { anchor: 'right', open: open, onClose: onClose, className: 'custom-drawer', ...rest, children: children }));
};
export default CustomDrawer;
